import type { ResourceId } from "src/api";

import { MATERIAL_DISPLAY } from "../../../../constants";

const depositUrl = (modelName: string) =>
  `${import.meta.env.BASE_URL}models/deposits/${modelName}.glb`;

export type DepositSize = "small" | "medium" | "big";

export interface DepositModelDefinition {
  modelUrl: string;
  scale?: number;
}

export const DEPOSIT_BASE_DEFINITIONS: Record<
  DepositSize,
  DepositModelDefinition
> = {
  small: { modelUrl: depositUrl("base-small"), scale: 0.25 },
  medium: { modelUrl: depositUrl("base-medium"), scale: 0.25 },
  big: { modelUrl: depositUrl("base-big"), scale: 0.25 }
};

// TODO: fill in other ore models once they arrive
const DIAMOND_ORE_MODELS: Record<DepositSize, DepositModelDefinition> = {
  small: { modelUrl: depositUrl("diamond-small"), scale: 0.25 },
  medium: { modelUrl: depositUrl("diamond-medium"), scale: 0.25 },
  big: { modelUrl: depositUrl("diamond-big"), scale: 0.25 }
};

export interface ResourceDepositDefinition {
  oreModels: Record<DepositSize, DepositModelDefinition>;

  // TODO: this is temp from when we only had diamond ore models, so we recolored it, remove later
  temporaryOreColor?: string;
}

export const RESOURCE_DEPOSIT_DEFINITIONS: Record<
  ResourceId,
  ResourceDepositDefinition
> = {
  iron: {
    oreModels: DIAMOND_ORE_MODELS,
    temporaryOreColor: MATERIAL_DISPLAY.iron.color
  },
  steel: {
    oreModels: DIAMOND_ORE_MODELS,
    temporaryOreColor: MATERIAL_DISPLAY.steel.color
  },
  "crucible-steel": {
    oreModels: DIAMOND_ORE_MODELS,
    temporaryOreColor: MATERIAL_DISPLAY["crucible-steel"].color
  },
  cobble: {
    oreModels: DIAMOND_ORE_MODELS,
    temporaryOreColor: MATERIAL_DISPLAY.cobble.color
  },
  stone: {
    oreModels: DIAMOND_ORE_MODELS,
    temporaryOreColor: MATERIAL_DISPLAY.stone.color
  },
  marble: {
    oreModels: DIAMOND_ORE_MODELS,
    temporaryOreColor: MATERIAL_DISPLAY.marble.color
  },
  electrum: {
    oreModels: DIAMOND_ORE_MODELS,
    temporaryOreColor: MATERIAL_DISPLAY.electrum.color
  },
  diamond: { oreModels: DIAMOND_ORE_MODELS },
  coal: { oreModels: DIAMOND_ORE_MODELS, temporaryOreColor: "#000000" },
  nuclear: { oreModels: DIAMOND_ORE_MODELS, temporaryOreColor: "#FFFFFF" }
};
